// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LayeredDataCore_visual__B53nY {
  position: relative;
  width: min(100%, 42rem);
  min-height: 34rem;
  margin-left: auto;
  margin-right: -4.5rem;
  margin-top: -2.2rem;
  overflow: visible;
  background: transparent;
}

.LayeredDataCore_visual__B53nY::before,
.LayeredDataCore_visual__B53nY::after {
  content: "";
  position: absolute;
  left: -10%;
  right: -18%;
  pointer-events: none;
  z-index: 1;
}

.LayeredDataCore_visual__B53nY::before {
  top: -16%;
  height: 22%;
  background: linear-gradient(
    to bottom,
    var(--color-background) 0%,
    rgba(0, 0, 0, 0.86) 48%,
    rgba(0, 0, 0, 0) 100%
  );
}

.LayeredDataCore_visual__B53nY::after {
  bottom: -14%;
  height: 18%;
  background: linear-gradient(
    to top,
    var(--color-background) 0%,
    rgba(0, 0, 0, 0.74) 42%,
    rgba(0, 0, 0, 0) 100%
  );
}

.LayeredDataCore_canvasMount__\\+5yJu {
  position: absolute;
  inset: -16% -18% -14% -10%;
  z-index: 0;
  mask-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.9) 10%,
    rgba(0, 0, 0, 1) 24%,
    rgba(0, 0, 0, 1) 72%,
    rgba(0, 0, 0, 0.78) 88%,
    rgba(0, 0, 0, 0.14) 97%,
    rgba(0, 0, 0, 0) 100%
  );
  -webkit-mask-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.9) 10%,
    rgba(0, 0, 0, 1) 24%,
    rgba(0, 0, 0, 1) 72%,
    rgba(0, 0, 0, 0.78) 88%,
    rgba(0, 0, 0, 0.14) 97%,
    rgba(0, 0, 0, 0) 100%
  );
}

.LayeredDataCore_canvasMount__\\+5yJu canvas {
  width: 100% !important;
  height: 100% !important;
  display: block;
}

.LayeredDataCore_canvas__6Twi1 {
  opacity: 0;
  transform: translateY(0.8rem) scale(0.985);
  transition: opacity 0.7s ease, transform 0.9s ease;
}

.LayeredDataCore_canvasReady__4QQMe {
  opacity: 1;
  transform: translateY(0) scale(1);
}

@media (max-width: 900px) {
  .LayeredDataCore_visual__B53nY {
    width: min(100%, 34rem);
    min-height: 28rem;
    margin: 0 auto;
  }

  .LayeredDataCore_visual__B53nY::before,
  .LayeredDataCore_visual__B53nY::after {
    left: -10%;
    right: -10%;
  }

  .LayeredDataCore_canvasMount__\\+5yJu {
    inset: -10%;
  }
}

@media (max-width: 640px) {
  .LayeredDataCore_visual__B53nY {
    width: min(100%, 24rem);
    min-height: 23rem;
  }

  .LayeredDataCore_canvasMount__\\+5yJu {
    inset: -6%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LayeredDataCore.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;EACX;;;;;GAKC;AACH;;AAEA;EACE,YAAY;EACZ,WAAW;EACX;;;;;GAKC;AACH;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,UAAU;EACV;;;;;;;;;GASC;EACD;;;;;;;;;GASC;AACH;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,0CAA0C;EAC1C,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE;IACE,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;;IAEE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".visual {\n  position: relative;\n  width: min(100%, 42rem);\n  min-height: 34rem;\n  margin-left: auto;\n  margin-right: -4.5rem;\n  margin-top: -2.2rem;\n  overflow: visible;\n  background: transparent;\n}\n\n.visual::before,\n.visual::after {\n  content: \"\";\n  position: absolute;\n  left: -10%;\n  right: -18%;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.visual::before {\n  top: -16%;\n  height: 22%;\n  background: linear-gradient(\n    to bottom,\n    var(--color-background) 0%,\n    rgba(0, 0, 0, 0.86) 48%,\n    rgba(0, 0, 0, 0) 100%\n  );\n}\n\n.visual::after {\n  bottom: -14%;\n  height: 18%;\n  background: linear-gradient(\n    to top,\n    var(--color-background) 0%,\n    rgba(0, 0, 0, 0.74) 42%,\n    rgba(0, 0, 0, 0) 100%\n  );\n}\n\n.canvasMount {\n  position: absolute;\n  inset: -16% -18% -14% -10%;\n  z-index: 0;\n  mask-image: linear-gradient(\n    to right,\n    rgba(0, 0, 0, 0) 0%,\n    rgba(0, 0, 0, 0.9) 10%,\n    rgba(0, 0, 0, 1) 24%,\n    rgba(0, 0, 0, 1) 72%,\n    rgba(0, 0, 0, 0.78) 88%,\n    rgba(0, 0, 0, 0.14) 97%,\n    rgba(0, 0, 0, 0) 100%\n  );\n  -webkit-mask-image: linear-gradient(\n    to right,\n    rgba(0, 0, 0, 0) 0%,\n    rgba(0, 0, 0, 0.9) 10%,\n    rgba(0, 0, 0, 1) 24%,\n    rgba(0, 0, 0, 1) 72%,\n    rgba(0, 0, 0, 0.78) 88%,\n    rgba(0, 0, 0, 0.14) 97%,\n    rgba(0, 0, 0, 0) 100%\n  );\n}\n\n.canvasMount canvas {\n  width: 100% !important;\n  height: 100% !important;\n  display: block;\n}\n\n.canvas {\n  opacity: 0;\n  transform: translateY(0.8rem) scale(0.985);\n  transition: opacity 0.7s ease, transform 0.9s ease;\n}\n\n.canvasReady {\n  opacity: 1;\n  transform: translateY(0) scale(1);\n}\n\n@media (max-width: 900px) {\n  .visual {\n    width: min(100%, 34rem);\n    min-height: 28rem;\n    margin: 0 auto;\n  }\n\n  .visual::before,\n  .visual::after {\n    left: -10%;\n    right: -10%;\n  }\n\n  .canvasMount {\n    inset: -10%;\n  }\n}\n\n@media (max-width: 640px) {\n  .visual {\n    width: min(100%, 24rem);\n    min-height: 23rem;\n  }\n\n  .canvasMount {\n    inset: -6%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"visual": `LayeredDataCore_visual__B53nY`,
	"canvasMount": `LayeredDataCore_canvasMount__+5yJu`,
	"canvas": `LayeredDataCore_canvas__6Twi1`,
	"canvasReady": `LayeredDataCore_canvasReady__4QQMe`
};
export default ___CSS_LOADER_EXPORT___;
